module.exports = __webpack_public_path__ + "img/reset-iemt.92b107e0.png";